import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SetorCliente } from '../../comum/modelos/setor-cliente';

@Component({
    selector: 'app-modal-ponto-fisico-setor',
    templateUrl: './modal-ponto-fisico-setor.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-ponto-fisico-setor.component.css']
})
export class ModalPontoFisicoSetorComponent implements OnInit {

    @Input() setorCliente: SetorCliente;

    constructor(private modalService: NgbModal) {
    }

    cadastrar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalPontoFisicoSetor',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/modal-ponto-fisico-setor/modal-ponto-fisico-setor.component.ts